// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cropMarks_root_SAtJo {
  position: relative;
  background: white;
  border: 40px solid white;
  z-index: 1;
}

.cropMarks_root_SAtJo:before {
  position: absolute;
  content: '';
  top: 0;
  bottom: 0;
  left: -40px;
  right: -40px;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  z-index: -1000;
}

.cropMarks_root_SAtJo:after {
  position: absolute;
  content: '';
  top: -40px;
  bottom: -40px;
  left: 0;
  right: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
  z-index: -1000;
}
`, "",{"version":3,"sources":["webpack://./src/components/cropMarks.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,6BAA6B;EAC7B,cAAc;AAChB","sourcesContent":[".root {\n  position: relative;\n  background: white;\n  border: 40px solid white;\n  z-index: 1;\n}\n\n.root:before {\n  position: absolute;\n  content: '';\n  top: 0;\n  bottom: 0;\n  left: -40px;\n  right: -40px;\n  border-top: 1px solid black;\n  border-bottom: 1px solid black;\n  z-index: -1000;\n}\n\n.root:after {\n  position: absolute;\n  content: '';\n  top: -40px;\n  bottom: -40px;\n  left: 0;\n  right: 0;\n  border-left: 1px solid black;\n  border-right: 1px solid black;\n  z-index: -1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `cropMarks_root_SAtJo`
};
module.exports = ___CSS_LOADER_EXPORT___;
